// @core/api/endpoints/booking/leave_waitlist.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/booking';

/**
 * Leave waitlist
 * Removes the customer from the waitlist.
 */
export async function LeaveWaitlist(
  entry_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/waitlist/:entry_id`;
  requestPath = requestPath.replace(':entry_id', encodeURIComponent(entry_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
